export default __webpack_public_path__ + "static/media/find.26d75c7e.svg";